import { APICfg } from 'services/api/api'
import { productSectionParse } from '../utils'
import { ExperienceSection, ExperienceSectionToAPI } from './experienceSection'

const apiCfg: APICfg = {
  endpoint: 'physicalexperiencessections',
  parse: productSectionParse,
  write: async (req: ExperienceSection): Promise<ExperienceSectionToAPI> => req,
}

export default apiCfg
